import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type ActionButtonsRootProps = {
  isSubmitting?: boolean;
  title?: string;
  icon?: React.ElementType;
  description?: string;
  buttonText: string;
  buttonColor: any;
  onConfirm?: () => void;
  actionIsLoading?: boolean;
};

export function ConfirmationDialogButton({
  title,
  description,
  icon,
  buttonText,
  buttonColor,
  onConfirm,
  actionIsLoading = false,
}: ActionButtonsRootProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Button
        fullWidth
        onClick={() => setOpen(true)}
        variant="contained"
        size="medium"
        startIcon={icon ? <Box component={icon} sx={{ fontSize: 20 }} /> : undefined}
        sx={{
          backgroundColor: buttonColor,
          "&:hover": {
            backgroundColor: buttonColor,
            filter: "brightness(0.9)",
          },
          "&:active": {
            backgroundColor: buttonColor,
            filter: "brightness(0.8)",
          },
        }}
      >
        {t(buttonText)}
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="action-dialog-title"
      >
        <DialogTitle
          id="action-dialog-title"
          sx={{
            typography: "h6",
            fontWeight: 700,
            color: "text.primary",
            lineHeight: 1.4,
            textAlign: "center",
            p: 2,
            pt: 4,
          }}
        >
          {t(title ?? "")}
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <WarningAmberIcon
            color="error"
            sx={{
              fontSize: 48,
            }}
          />
          <Typography variant="body1" color="text.secondary">
            {t(description ?? "")}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            px: 4,
            pb: 4,
            pt: 3,
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button fullWidth variant="outlined" color="secondary" onClick={() => setOpen(false)}>
            Annuler
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={actionIsLoading}
          >
            {actionIsLoading ? <CircularProgress size={20} color="inherit" /> : t("common.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
